import * as yup from 'yup';
import { MAX_TAGS } from '../../constants';
import { FieldValidator } from '../../types';

export const validator: FieldValidator = () =>
  yup.object({
    tags: yup.array().of(yup.string()).max(MAX_TAGS),
  });
